import assert from 'assert-ts';
import type {
  Data,
  DataValue,
  FieldRequired,
  FieldRequiredSimple,
  RefPath,
} from '../types';
import {evaluateCondition} from './evaluateCondition';

export const evaluateFieldRequired = (
  field: FieldRequired | undefined,
  valuePath: RefPath,
  localScope: Data | undefined,
  globalScope: Data | undefined,
  relatedScope: Data | undefined,
  localValue: DataValue | undefined,
): FieldRequiredSimple | undefined => {
  if (typeof field === 'boolean' || field === 'should' || field === undefined) {
    return field;
  }

  if (field.required) {
    return evaluateCondition(field.required, {
      valuePath,
      localScope,
      globalScope,
      relatedScope,
      value: localValue,
    });
  }

  if (field.should) {
    return evaluateCondition(field.should, {
      valuePath,
      localScope,
      globalScope,
      relatedScope,
      value: localValue,
    })
      ? 'should'
      : false;
  }

  assert(
    !field.should && !field.required,
    'FieldRequired should have should or required',
  );
};
